import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgResourcesGuideArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33345 9.9999H16.6669M11.6668 14.9999L16.6669 9.9999L11.6668 4.9999",
		stroke: "#474747",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgResourcesGuideArrowRight;
